import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
export default (function () {
    return getFallbackValueIfNull(getStore().newMailSound, !!(getUserConfiguration().UserOptions.NewItemNotify & 1 /* Sound */));
});
//# sourceMappingURL=isNewMailSoundEnabled.js.map